module.exports = __webpack_public_path__ + "img/04logo-tee2021.2db3ea7e.png";